import { useLatestFn } from '@studio/react-utils/hooks';
import type { ReactElement } from 'react';
import { useStore } from './store/hooks.js';
import { useWiring } from './wiring.js';
import * as _Footer from '#~/common/editor/footer/index.js';
import { logger } from '#~/logger/index.js';

/** Settings `<Footer>` component. */
export const Footer = (props: _Footer.Props): ReactElement => {
  const isReady = useStore((µ) => µ.isReady);
  const wiring = useWiring();

  const handleNext = useLatestFn(() => {
    if (!isReady) {
      return;
    }

    wiring.handleCommit().catch((error) => {
      logger.critical(error);
    });
  });

  return (
    <_Footer.Root className='justify-start gap-8' {...props}>
      <_Footer.Button onClick={wiring.handleRemove} variant='danger'>
        Delete Source
      </_Footer.Button>

      <_Footer.Button className='ml-auto' onClick={wiring.handleCancel} variant='secondary'>
        Cancel
      </_Footer.Button>

      <_Footer.Next disabled={!isReady} label='Save Changes' onClick={handleNext} />
    </_Footer.Root>
  );
};
